exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-testsList-TestsListTable-actionIcon{cursor:pointer;color:#15284b}.src-components-testsList-TestsListTable-qcIcon{display:block;width:20px;height:20px;margin:0 auto}", ""]);

// exports
exports.locals = {
	"actionIcon": "src-components-testsList-TestsListTable-actionIcon",
	"qcIcon": "src-components-testsList-TestsListTable-qcIcon"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/testsList/TestsListTable/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/testsList/TestsListTable/styles.scss
// module chunks = 1